const setArrayValues = item => {
  return item.values[0]?.id ? item.values.map(val => val.id) : item.values;
};

const generateValues = item => {
  if (item.attribute_key === 'content') {
    const values = item.values || '';
    return values.split(',');
  }
  if (Array.isArray(item.values)) {
    return setArrayValues(item);
  }
  if (typeof item.values === 'object') {
    return [item.values.id];
  }
  if (!item.values) {
    return [];
  }
  return [item.values];
};

// Attributes that are only handled client-side and should not be sent to the backend
export const FRONTEND_ONLY_ATTRIBUTES = ['unread_count'];

const generatePayload = data => {
  // Make a copy of data to avoid vue data reactivity issues
  const filters = JSON.parse(JSON.stringify(data));
  let payload = filters
    .filter(item => !FRONTEND_ONLY_ATTRIBUTES.includes(item.attribute_key))
    .map(item => {
    // If item key is content, we will split it using comma and return as array
    // FIX ME: Make this generic option instead of using the key directly here
    item.values = generateValues(item);
    return item;
  });

  if (payload.length === 0) {
    return { payload: [] };
  }

  // For every query added, the query_operator is set default to and so the
  // last query will have an extra query_operator, this would break the api.
  // Setting this to null for all query payload
  payload[payload.length - 1].query_operator = undefined;
  return { payload };
};

/**
 * Generates a full payload including frontend-only attributes.
 * Used for saving custom views/folders so client-side filters are preserved.
 */
export const generateFullPayload = data => {
  const filters = JSON.parse(JSON.stringify(data));
  let payload = filters.map(item => {
    item.values = generateValues(item);
    return item;
  });

  if (payload.length === 0) {
    return { payload: [] };
  }

  payload[payload.length - 1].query_operator = undefined;
  return { payload };
};

export default generatePayload;
